import { forwardRef, ReactNode, useImperativeHandle, useState } from 'react';

type MultiStepContentProps = {
	children: ReactNode[];
};

export type MultiStepContentHandles = {
	handleNextStep: () => void;
	handlePreviousStep: () => void;
};

export const MultiStepContent = forwardRef<
	MultiStepContentHandles,
	MultiStepContentProps
>(({ children }, ref) => {
	const [currentStep, setCurrentStep] = useState(0);
	const totalSteps = children.length;

	const currentChild = children[currentStep];

	const handleNextStep = () => {
		setCurrentStep(state => {
			if (state >= totalSteps - 1) return state;

			return state + 1;
		});
	};

	const handlePreviousStep = () => {
		setCurrentStep(state => {
			if (state <= 0) return 0;

			return state - 1;
		});
	};

	useImperativeHandle(ref, () => ({
		handleNextStep,
		handlePreviousStep
	}));

	if (!currentChild) return null;

	return <>{currentChild}</>;
});
